/** Continuity copy for the Admin Transfer / Resend handover invite preview.

The live mailer is `handover_invite_copy` / `send_handover_invite`. This mirrors
the default subject and body so the preview matches what will be sent. A
personal note is additive — it never replaces these lines.
*/

export const HANDOVER_INVITE_SUBJECT = 'your website is ready';

export function handoverInviteSubject(siteName) {
  const name = String(siteName || 'Your website').trim() || 'Your website';
  return `${name} — your website is ready`;
}
export const PERSONAL_NOTE_MAX = 500;

export function sanitizePersonalNote(raw) {
  return String(raw || '')
    .replace(/\r\n/g, '\n')
    .replace(/\r/g, '\n')
    .replace(/[ \t]+/g, ' ')
    .replace(/\n{3,}/g, '\n\n')
    .trim()
    .slice(0, PERSONAL_NOTE_MAX);
}

export function handoverInviteeName(email, owner) {
  const invite = (email || '').trim().toLowerCase();
  const ownerEmail = (owner?.email || '').trim().toLowerCase();
  const name = (owner?.full_name || '').trim();
  if (invite && invite === ownerEmail && name) return name;
  return (invite.split('@')[0] || 'there');
}

export function handoverInvitePreview({ inviteeName, siteName, siteUrl, personalNote } = {}) {
  const note = sanitizePersonalNote(personalNote);
  return {
    subject: handoverInviteSubject(siteName),
    greeting: `Hi ${inviteeName || 'there'},`,
    liveLine: `${siteName || 'Your website'} is live at ${siteUrl || ''}`,
    personalNote: note,
    setPassword: 'It is yours — set a password and you can edit any page yourself.',
    cta: 'Set your password',
    linkNote: 'This link works for 7 days. Sign in at EasyPeazy afterwards — that is not ChurchConnect.',
  };
}
